<template>
    <el-table :data="companies" rowClassName="cpointer" @row-click="companySelected">
        <el-table-column prop="name" :label="$t.__('common.labels.society_name')">
        </el-table-column>
        <el-table-column prop="companyType" :label="$t.__('common.labels.type')"> </el-table-column>
        <el-table-column prop="companyId" :label="$t.__('companysearch.GB_results.company_id')">
        </el-table-column>
        <el-table-column prop="address" :label="$t.__('common.labels.address')"> </el-table-column>
    </el-table>
</template>
<script>
export default {
    props: {
        companies: {
            required: true,
            type: Array,
        },
        countryCode: {
            required: true,
            type: String,
        },
    },
    methods: {
        companySelected(row) {
            this.$emit('companySelected', {
                companyId: row.companyId,
                queryParams: { countryCode: this.countryCode },
            });
        },
    },
};
</script>
